module.exports = __webpack_public_path__ + "img/20200513_160935.7ad00132.jpg";